import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ratchet_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  // Step-up do painel interno (owners@): válido só nesta sessão de aba.
  const panelToken = sessionStorage.getItem("ratchet_panel_token");
  if (panelToken) config.headers["X-Panel-Token"] = panelToken;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/app") || path === "/onboarding") {
        localStorage.removeItem("ratchet_token");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);
